export default [
  {
    path: '/auth/verify/:type',
    name: 'verify',
    component: () => import('@/views/auth/Verify.vue'),
    meta: {
      goHome: true,
      pageTitle: 'Verify',
      pageIcon: 'UserIcon',
      layout: 'full'
    },
  },
  {
    path: '/auth/reset-password/:type',
    name: 'reset-password',
    component: () => import('@/views/auth/ResetPassword.vue'),
    meta: {
      goHome: true,
      pageTitle: 'Reset Password',
      pageIcon: 'UserIcon',
      layout: 'full'
    },
  },
  {
    path: '/auth/forgot-password/:type',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPassword.vue'),
    meta: {
      goHome: true,
      pageTitle: 'Reset Password',
      pageIcon: 'UserIcon',
      layout: 'full'
    },
  },
]